import { z } from "zod/v4";
import {
	bankAccountResponseSchema,
	bankTransactionResponseSchema,
	importResultSchema,
	matchResultSchema,
} from "../../schemas/finance";
import { fetchApi, fetchFormData, fetchVoid } from "../client/internal";

export const banking = {
	listAccounts: (clubId: string) =>
		fetchApi(`/${clubId}/banks`, z.array(bankAccountResponseSchema)),
	createAccount: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/banks`, bankAccountResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	updateAccount: (clubId: string, bankId: string, data: unknown) =>
		fetchApi(`/${clubId}/banks/${bankId}`, bankAccountResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	deleteAccount: (clubId: string, bankId: string) =>
		fetchVoid(`/${clubId}/banks/${bankId}`, { method: "DELETE" }),
	listTransactions: (
		clubId: string,
		bankId: string,
		params?: { status?: string; from?: string; to?: string },
	) => {
		const qs = new URLSearchParams();
		if (params?.status) qs.set("status", params.status);
		if (params?.from) qs.set("from", params.from);
		if (params?.to) qs.set("to", params.to);
		const q = qs.toString();
		return fetchApi(
			`/${clubId}/banks/${bankId}/transactions${q ? `?${q}` : ""}`,
			z.array(bankTransactionResponseSchema),
		);
	},
	importTransactions: (clubId: string, bankId: string, formData: FormData) =>
		fetchFormData(`/${clubId}/banks/${bankId}/import`, importResultSchema, formData),
	autoMatch: (clubId: string, bankId: string) =>
		fetchApi(
			`/${clubId}/banks/${bankId}/automatch`,
			z.object({ results: z.array(matchResultSchema) }),
			{ method: "POST" },
		),
	manualMatch: (clubId: string, bankId: string, txId: string, invoiceId: string) =>
		fetchApi(
			`/${clubId}/banks/${bankId}/transactions/${txId}/match`,
			z.object({ matched: z.boolean() }),
			{
				method: "POST",
				body: JSON.stringify({ invoice_id: invoiceId }),
			},
		),
	bookTransaction: (clubId: string, bankId: string, txId: string, accountId: string) =>
		fetchApi(
			`/${clubId}/banks/${bankId}/transactions/${txId}/book`,
			z.object({ booked: z.boolean() }),
			{
				method: "POST",
				body: JSON.stringify({ account_id: accountId }),
			},
		),
	ignoreTransaction: (clubId: string, bankId: string, txId: string) =>
		fetchApi(
			`/${clubId}/banks/${bankId}/transactions/${txId}/ignore`,
			z.object({ ignored: z.boolean() }),
			{ method: "POST" },
		),
};
